import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const employeeLeaveBalanceService = {
  getByEmployee: async (employeePersonalInformationId) => {
    // This call will now return a 400 error if Year is not set in backend
    return await axios.get(`${domain}/api/EmployeeLeaveBalance/leave-credits/${employeePersonalInformationId}`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/EmployeeLeaveBalance`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/EmployeeLeaveBalance/${id}`, payload, { headers });
  },
};

export default employeeLeaveBalanceService;